import { FavoriteProduct } from '@services/AuthService/query/loadUserQuery';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';

import { DELIVERY_SECTION_ID } from '../CalculationsMenu/consts';

/**
 * Продукт из записи избранного, null — если данные битые
 */
export const getFavoriteProduct = (favorite: FavoriteProduct): OrderProduct | null => {
  try {
    return JSON.parse(favorite.data);
  } catch (e) {
    return null;
  }
};

/**
 * Раздел меню для продукта из избранного. Таможенные платежи и битые данные — null.
 * TODO: убрать исключение таможенных платежей, когда для них сделают восстановление и шаринг
 */
export const getFavoriteSectionId = (product: OrderProduct): string | null => {
  if (product.product_type === 'route') {
    return DELIVERY_SECTION_ID;
  }

  try {
    const data = JSON.parse(product.data);

    if (Array.isArray(data) && data[0]?.type === 'customs-payments') {
      return null;
    }

    const sectionName =
      data?.sectionName ?? (Array.isArray(data) ? JSON.parse(data[0]?.data)?.sectionName : null);

    return sectionName?.id !== undefined && sectionName?.id !== null ? String(sectionName.id) : null;
  } catch (e) {
    return null;
  }
};
